<template>
  <div id="func-62">
    <div v-if="canal" class="header">
      <FuncionalidadeHeader
        titulo="Descredenciados"
        :voltar="!isWidget && canal !== 'appEmbed'"
      />
    </div>

    <div class="content">
      <RedeDescredenciada />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import RedeDescredenciada from './RedeDescredenciada.vue'

export default {
  name: 'Func4RedeDescredenciada',
  components: { RedeDescredenciada, FuncionalidadeHeader },
  data () {
    return {
      filters: {}
    }
  },
  computed: {
    ...mapGetters('SetupApp', ['isWidget']),
    ...mapState('SetupApp', ['canal'])
  }
}
</script>

<style scoped lang="less">
.content {
  display: flex;
  flex-flow: row;
  border-top: 1px solid lightgray;
  width: 100%;
}

.densidade-1, .densidade-2, .densidade-3 {
  .header,
  .listagem-wrapper {
    display: none;
  }
}

.listagem-wrapper {
  flex: 1;
  height: 100%;
  overflow: auto;
  border-left: 1px solid #EEEEEE;
  width: 100%;
}
</style>
